import config from '../config'
// const baseUrl = process.env.API
const baseUrl = config.api.host
export default {
  user: {
    register: '/base-api/user/userRegister',
    logOut: '/user/user/loginOut',
    imgCode: baseUrl + '/user/user/getImageCaptcha',
    login: baseUrl + '/base-api/user/userLogin', // '/user/user/userLogin'
    detail: '/user/userDetail/getOneByToken',
    companyInfo: '/user/company/getOneByToken',
    auth: '/user/userDetail/userNameAuth',
    sms: '/user/user/sendSMS',
    active: '/base-api/user/validateMobilePhoneCaptcha',
    changeMobile: 'base-api/user/confirmValidateMobilePhoneCaptcha',
    overview: '/user/userDetail/getPersonalAccountDetails',
    authList: '/user/persontype/list',
    modityPwd: '/base-api/user/updatePassword',
    retrievePassword: '/base-api/user/retrievePassword',
    email: '/base-api/user/sendEmail',
    personcert: '/user/personcert/save',
    checkEmailLink: '/base-api/accountCenter/email/checkEmailLink',
    queryQualificationByPrams: '/user/personcert/queryQualificationByPrams',
    getRealDetails: '/user/userDetail/getRealDetails',
    getUserAuthByToken: '/user/user/getUserAuthByToken',
    getCompany: '/user/company/vagueSearch',
    applyAuth: '/user/company/applyAuth',
    personcertList: '/user/personcert/list',
    saveCompanyCert: '/user/companyCert/saveCompanyCert',
    queryQualificationByCode: '/user/companyCert/queryQualificationByCode/',
    personaduitlog: '/user/personaduitlog/list',
    existUserInfo: '/user/user/existUserInfo',
    queryCompanyCert: '/user/companyCert/queryCompanyCert/',
    getPracticeVerityType: '/user/companyCert/queryQualificationByPrams',
    findPassword: '/user/user/findPassword',
    queryCompanyType: '/user/companyCert/queryCompanyType/',
    getCompanyAduitById: '/user/company/getCompanyAduitById',
    queryCompanyBaseDetailById: '/user/company/queryCompanyBaseDetailById/',
    getAduitLogById: '/user/company/getAduitLogByUserId',
    personQueryQualification: '/user/personcert/queryQualificationByPrams',
    getAccountProfileVo: '/user/user/getAccountProfileVo',
    companyTypeAduitLogList: '/user/companyCert/companyTypeAduitLogList/',
    getPersonDetailId: '/user/userDetail/getPersonDetailId',
    expireSmsTime: '/user/user/expireSmsTime',
    existMobile: '/user/user/existMobile',
    updateQualifications: 'user/personcert/updateQualifications',
    queryCompanyCertByCompanyTypeId: '/user/companyCert/queryCompanyCertByCompanyTypeId/',
    reSubmitCompanyCert: '/user/companyCert/reSubmitCompanyCert',
    existEmail: 'user/user/existEmail',
    queryAduitedJointRoles: '/user/jointRole/queryAduitedJointRoles',
    jointRoleList: '/user/jointRole/queryCompanyJointRoles',
    personCertByTypeId: '/user/personcert/personCertByTypeId', // 获取个人职业认证详情
    updateAvatar: '/user/user/updateAccountLogo', // 更新头像
    queryCompanySuccessCert: '/user/companyCert/queryCompanySuccessCert/',
    applyAduit: 'user/jointRole/applyAduit',
    queryAduitLogs: 'user/jointRole/queryAduitLogs/',
    uploadDepositProve: 'user/jointRole/uploadDepositProve',
    existUserName: 'user/user/existUserName',
    hasAduitByCompanyName: 'user/company/hasAduitByCompanyName',
    companyServiceById: '/control/companyservice/companyServiceById',
    accurateSearch: 'user/company/accurateSearch',
    userAuth: 'user/user/userAuth',
    isSoleIdCard: 'user/userDetail/isSoleIdCard',
    accountHasCancel: 'user/user/accountHasCancel',
    allCompanyServices: '/control/companyservice/allCompanyServices',
    getObj: '/user/personcert/getObj' // 执业注册审核记录
  },
  upload: {
    file: '/base/fileUpload/uploadFileSimple',
    file2: '/base/fileUpload/uploadFileSimpleParameter'
  },
  base: {
    addressList: '/base/sysaddress/list',
    sysdictionary: '/base/sysdictionary/list',
    getByEmailPostfix: '/base/emailAddress/getByEmailPostfix'
  }
}



// WEBPACK FOOTER //
// ./src/config/api.js